module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-Hikaku_KaitoriCase_5d585b857283090775df952da6d52370.png";